import axios from 'axios'
import { transformResponse } from 'src/utils/response'

export default ({ Vue }) => {
  if (!process.env.BASE_URL && !window.location.hostname.endsWith('likvi.de')) {
    throw new Error('Invalid origin ' + window.location)
  }

  axios.defaults.baseURL = process.env.BASE_URL || window.location.origin + '/api'
  axios.defaults.transformResponse = [transformResponse]

  Vue.prototype.$axios = axios
}
